<template lang="pug">
vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="addSelected" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="selected.length >= 1" :vm-active="isTransfersModalVisible" :vm-title="$t('strings.select_transfers')")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      vm-table(multiple v-model="selected" max-height="350px" :data="transfers")
        template(slot="thead")
          vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('transfers.' + column) }}
        template(slot-scope="{data}")
          vm-tr(v-if="tr.quantity_details > 0" :data="tr" :key="indextr" v-for="(tr, indextr) in data")
            vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
              slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
              slot(v-if="column != 'status_reception' && column != 'status_transfer' && column != 'created_at'") {{data[indextr][column]}}
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('LabelGroups')

export default {
  name: 'ModalLabelOrders',
  mixins: [ModalMixin1],
  data: () => ({
    selected: [],
    columns: ['folio', 'origin', 'destination', 'comments', 'created_at']
  }),
  computed: {
    ...mapGetters(['isTransfersModalVisible', 'transfers'])
  },
  methods: {
    ...mapActions([
      'addLabelsFromTransfers',
      'setModalTransferHidden',
      'setLoader'
    ]),
    async addSelected () {
      const ids = this.selected.map(element => element.id)
      await this.addLabelsFromTransfers({ ids: ids, folio: this.selected[0].folio })
      this.setLoader(false)
      this.setModalTransferHidden()
      this.selected = []
    },
    close () {
      this.setModalTransferHidden()
    }
  }
}
</script>
